<template>
  <div class="wrapper">
    <h6 class="card-title">Steps to authorise your account:</h6>
    <ul>
      <li>
        Go to
        <a href="https://shopify.dev/apps/auth/admin-app-access-tokens" target="_black"> Link </a>
        and generate Access token as instructed.
      </li>
    </ul>
    <div class="printify_popup_wrap">
      <div class="printify_popup_container row">
        <div class="position-relative form-group col-12">
          <span>ID:&nbsp;</span>
          <span class="select-all">{{ data.id }}</span>
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Shop Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Shop Url*</label>
          <input class="form-control mt-2" type="text" :value="integration.api.url" @change.stop.prevent="store.commit('integration.api.url', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label for="exampleText" class="">Token</label>
          <textarea class="form-control" @change.stop.prevent="store.commit('integration.api.token', $event.target.value)"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.accountId
    },
    submitUri() {
      return `sale-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    integration() {
      return _.mergeLeft(
        {
          api: {
            token: '',
            url: ''
          }
        },
        this.data.integration || {}
      )
    }
  },
  mounted() {
    this.$emitter.on('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  unmounted() {
    this.$emitter.off('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  methods: {
    submit(data) {
      this.submitForm(data, {
        done: () => {
          this.$emitter.emit('TableList.Refresh')
          this.$emit('close')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
